import { render, staticRenderFns } from "./PaperlitParameters.vue?vue&type=template&id=488aca9a&scoped=true"
import script from "./PaperlitParameters.vue?vue&type=script&lang=js"
export * from "./PaperlitParameters.vue?vue&type=script&lang=js"
import style0 from "./PaperlitParameters.vue?vue&type=style&index=0&id=488aca9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488aca9a",
  null
  
)

export default component.exports